/**
 * The viewer's declared server state: the project's active geo
 * elements. Freshness comes from the stream bridge (parsed
 * invalidates this key) -- never from polling.
 */
import { useQuery } from '@tanstack/react-query';
import { API_BASE, authFetch, type ActiveGeoElement } from '../../api';

export function useElements(projectId: string) {
  return useQuery<ActiveGeoElement[]>({
    queryKey: ['elements', projectId],
    queryFn: async () => {
      const res = await authFetch(
        `${API_BASE}/v1/viewer/elements?project_id=${encodeURIComponent(projectId)}`,
      );
      if (!res.ok) throw new Error(`viewer elements: ${res.status}`);
      return (await res.json()) ?? [];
    },
  });
}
